import { useState } from "react"
import Campaign from "../../templates/Campaign/Campaign"
import { Button } from "reactstrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircle, faMinus, faPlus } from "@fortawesome/free-solid-svg-icons"
import { SystemMessageContext } from "../../context/SystemMessageContext"
import { useContext } from "react"
import AffiliateSearch from '../AffiliateSearch/AffiliateSearch'
import Affiliate from '../../templates/Affiliate/Affiliate'
import { OverlayTrigger, Tooltip } from "react-bootstrap"
import { Modal } from "react-bootstrap"
import RatesModal from "../../pages/Campaign/CampaignSettings/Edit/Rates/RatesModal"
import SpecialRatesModal from "../SpecialRatesModal/SpecialRatesModal"
import useCallApi from "../../hooks/useCallApi"
import Dollars from "../../templates/Dollars/Dollars"
import Loading from "../../templates/UI/Loading/Loading"

const CampaignPitch = ({ campaign, campaignPitch, data, setData, order, campaignPitchIndex, status, refetch, setSaveNeeded, ratePitchId }) => {
    const { showSystemMessage } = useContext(SystemMessageContext)
    const [selectedRateName, setSelectedRateName] = useState('')
    // Use an array for affiliates, one per rate row
    const [affiliates, setAffiliates] = useState([])

    // Helper to set affiliate at a specific index
    const setAffiliateItem = (index, value) => {
        setAffiliates(prev => {
            const updated = [...prev]
            updated[index] = value
            return updated
        })
    }

    const [rate, setRate] = useState()
    const addRate = async (e) => {
        e.preventDefault()
        setSaveNeeded(true)
        if (!rate) {
            showSystemMessage('error', 'Please select a rate to add')
            return
        }
        let tempCampaignPitch = campaignPitch
        tempCampaignPitch.rates = [...tempCampaignPitch.rates, { ...rate, proposedRate: '' }]

        let tempData = data
        tempData.campaignPitches = tempData.pitch.campaignPitches.map(cp => {
            if (cp.id === campaignPitch.id) {
                return tempCampaignPitch
            }
            return cp
        })
        setData({ ...tempData })
        //showSystemMessage('success', 'Rate added successfully')
        setRate()

    }
    const addAffiliateToRate = (thisRate, index) => {
        setSaveNeeded(true)
        const affiliate = affiliates[index]
        if (!affiliate || !affiliate.id) {
            showSystemMessage('error', 'Please select an affiliate to add')
            return
        }
        if (!thisRate || !thisRate.name) {
            showSystemMessage('error', 'Please select a rate to add the affiliate to')
            return
        }
        let tempCampaignPitch = campaignPitch

        // Create a new rate object instead of modifying the existing one
        const newRate = {
            ...thisRate,
            affiliate: affiliate,
            proposedRate: ''
        }
        // Add only the new rate to the array
        tempCampaignPitch.rates.push(newRate)

        let tempData = data
        tempData.campaignPitches = tempData.pitch.campaignPitches.map(cp => {
            if (cp.id === campaignPitch.id) {
                return tempCampaignPitch
            }
            return cp
        })

        setData({ ...tempData })
        // showSystemMessage('success', 'Affiliate added to rate successfully')
        // Clear only the affiliate at this index
        setAffiliateItem(index, undefined)
    }

    const SpecialRate = ({ rate, campaign, isForm, isComplete, status }) => {
        const [SRMIsOpen, setSRMIsOpen] = useState(false)
        const { data: specialData, dataLoaded: specialDataLoaded } = useCallApi(`affiliate/${rate.affiliate?.id}/${campaign.id}/specialRate?ratename=${rate.name}`, 'GET', {}, [rate, campaign])
        return (
            specialDataLoaded ?
                <tr>
                    <td width='25%'>

                        <Affiliate aid={rate.affiliate.id} name={rate.affiliate.name} />
                    </td>
                    <td width='25%' align="right" className={status.code === 'D' ? (parseFloat(rate.originalNetRate) !== parseFloat(rate.proposedRate) ? 'text-danger' : 'text-success') : ''}>
                        {specialData.success && specialData.rate?.net_rate_text
                            ? (specialData.rate?.display_net_rate_text && specialData.rate?.net_rate_text === '100% of sale'
                                ? ''
                                : specialData.rate.net_rate_text)
                            : ''}
                    </td>
                    <td width='25%' align="right" className={status.code === 'D' ? (parseFloat(rate.originalDisplayNetRate) !== parseFloat(rate.proposedRate) ? 'text-danger' : 'text-success') : ''}>
                        {(specialData.success && specialData.rate?.display_net_rate_text) ? specialData.rate.display_net_rate_text : ''}
                    </td>
                    <td width='25%' align="right">
                        {isForm ? (
                            <input
                                className="form-control form-control-sm text-right"
                                defaultValue={rate.proposedRate}
                                data-campaignpitch-index={campaignPitchIndex}
                                data-rate-name={rate.name}
                                data-affiliate-id={rate.affiliate && rate.affiliate.id ? rate.affiliate.id : undefined}
                                onBlur={(e) => {
                                    //stops this data from resetting when you change state
                                    if (e.target.value !== rate.proposedRate) {
                                        let tempCampaignPitch = campaignPitch;
                                        const rateToUpdate = tempCampaignPitch.rates.find(r =>
                                            r.name === rate.name &&
                                            r.affiliate?.id === rate.affiliate?.id
                                        );
                                        if (rateToUpdate) {
                                            rateToUpdate.proposedRate = e.target.value;
                                            let tempData = { ...data };
                                            tempData.campaignPitches = tempData.pitch.campaignPitches.map(cp => {
                                                if (cp.id === campaignPitch.id) {
                                                    return tempCampaignPitch;
                                                }
                                                return cp;
                                            });
                                            setData(tempData);
                                            setSaveNeeded(true);
                                        }
                                    }
                                }}
                            />
                        ) : (
                            <span>{rate.proposedRate || 'Not Set'}</span>
                        )}
                    </td>
                    <td width='25%' className="text-right">
                        {isForm ? (
                            <>
                                {(status.code !== 'A' && status.code !== 'C' && status.code !== 'X' && status.code !== 'P') && (
                                    <button className="btn btn-link text-danger" onClick={(e) => {
                                        e.preventDefault()
                                        setSaveNeeded(true)
                                        let tempCampaignPitch = campaignPitch
                                        tempCampaignPitch.rates = tempCampaignPitch.rates.filter(r => !(r.name === rate.name && r.affiliate && r.affiliate.id === rate.affiliate.id))
                                        let tempData = data
                                        tempData.campaignPitches = tempData.pitch.campaignPitches.map(cp => {
                                            if (cp.id === campaignPitch.id) {
                                                return tempCampaignPitch
                                            }
                                            return cp
                                        })
                                        setData({ ...tempData })
                                        // showSystemMessage('success', 'Affiliate removed from rate successfully')
                                        // Don't want to show messages unless data is modified in the back end
                                    }}>
                                        <FontAwesomeIcon icon={faMinus} />
                                    </button>
                                )}
                            </>
                        ) : (
                            !isComplete && (
                                <>
                                    <FontAwesomeIcon 
                                        icon={!specialData ? "cog" : "pencil-alt"} 
                                        className="text-warning cursor-pointer"
                                        onClick={() => setSRMIsOpen(true)}
                                        style={{ cursor: 'pointer' }}
                                    />
                                    <Modal show={SRMIsOpen} onHide={() => setSRMIsOpen(false)} size="lg">
                                        <SpecialRatesModal setIsOpen={setSRMIsOpen} affiliate={rate.affiliate} campaign={campaignPitch} refetch={refetch} showSystemMessage={showSystemMessage} ratename={!specialData ? '' : rate.name} ratePitchId={ratePitchId} />
                                    </Modal>
                                </>
                            )
                        )}
                    </td>
                </tr>
                :
                <Loading />

        )
    }

    const Rate = ({ campaignPitchRate, campaignRate, index, isForm, isComplete, status }) => {
        const [RmIsOpen, setRmIsOpen] = useState(false)
        return (

            <div className="card mt-2">
                <div className="card-header d-flex align-items-center justify-content-between">
                    <div>
                        {campaignRate.default_flag === 'Y' && (
                            <OverlayTrigger placement="top" overlay={<Tooltip id="default-rate-tooltip">Default Rate</Tooltip>} >
                                <FontAwesomeIcon icon={faCircle} className="mr-1" style={{ color: 'green', fontSize: '10px' }} />
                            </OverlayTrigger>
                        )}
                        <span>{campaignRate.name || 'unknown'}</span>
                    </div>
                    <div>
                        {isForm ? (
                            <>
                                {(status.code !== 'A' && status.code !== 'C' && status.code !== 'X' && status.code !== 'P') && (
                                    <button className="btn btn-link text-danger" onClick={(e) => {
                                        e.preventDefault()
                                        setSaveNeeded(true)
                                        let tempCampaignPitch = campaignPitch
                                        // Update filter condition to remove all rates with the same name
                                        // regardless of whether they have an affiliate or not
                                        tempCampaignPitch.rates = tempCampaignPitch.rates.filter(r => r.name !== campaignPitchRate.name)
                                        let tempData = data
                                        tempData.campaignPitches = tempData.pitch.campaignPitches.map(cp => {
                                            if (cp.id === campaignPitch.id) {
                                                return tempCampaignPitch
                                            }
                                            return cp
                                        })
                                        setData({ ...tempData })
                                        //showSystemMessage('success', 'Rate and all associated affiliates removed successfully')

                                    }}>
                                        <FontAwesomeIcon icon={faMinus} />
                                    </button>
                                )}
                            </>
                        ) : (
                            !isComplete &&
                            <>
                                <RatesModal ratePitchScreen isOpen={RmIsOpen} setIsOpen={setRmIsOpen} selectedRateName={campaignPitchRate.name} campaign={campaign} campaignId={campaignPitch.id} refetch={refetch} ratePitchId={ratePitchId} />
                                <Button className="btn btn-sm ml-2 text-nowrap" color='warning' onClick={() => setRmIsOpen(true)}>Edit Rate </Button>
                            </>
                        )}
                    </div>
                </div>

                <div className="card-body">
                    <table className="table table-sm w-100">
                        <thead>
                            <tr>
                                <th width="30%"></th>
                                <th width="25%" className="text-right">Net Rate</th>
                                <th width="25%" className="text-right">D. Net Rate</th>
                                <th width="20%" className="text-right">Proposed Rate</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td width='25%'><i>{campaignRate.description || 'No Description'}</i></td>
                                <td width='25%' align="right" className={status.code === 'D' ? (parseFloat(campaignPitchRate.originalNetRate) !== parseFloat(campaignPitchRate.proposedRate) ? 'text-danger' : 'text-success') : ''}>
                                    {campaignRate.net_rate_text
                                        ? (campaignRate.display_net_rate_text && campaignRate.net_rate_text === '100% of sale'
                                            ? ''
                                            : campaignRate.net_rate_text)
                                        : ''}
                                </td>
                                <td width='25%' align="right" className={status.code === 'D' ? (parseFloat(campaignPitchRate.originalDisplayNetRate) !== parseFloat(campaignPitchRate.proposedRate) ? 'text-danger' : 'text-success') : ''}>{campaignRate.display_net_rate_text || ''}</td>
                                <td width='25%' align="right">
                                    {isForm ? (
                                        <input
                                            className="form-control form-control-sm text-right"
                                            defaultValue={campaignPitchRate.proposedRate}
                                            data-campaignpitch-index={campaignPitchIndex}
                                            data-rate-name={campaignPitchRate.name}
                                            onBlur={(e) => {
                                                if (e.target.value !== campaignPitchRate.proposedRate) {
                                                    // Update the local data structure only on blur
                                                    let tempCampaignPitch = campaignPitch;
                                                    const rate = tempCampaignPitch.rates.find(r =>
                                                        r.name === campaignPitchRate.name &&
                                                        !r.affiliate
                                                    );
                                                    if (rate) {
                                                        rate.proposedRate = e.target.value;
                                                        let tempData = { ...data };
                                                        tempData.campaignPitches = tempData.pitch.campaignPitches.map(cp => {
                                                            if (cp.id === campaignPitch.id) {
                                                                return tempCampaignPitch;
                                                            }
                                                            return cp;
                                                        });
                                                        setData(tempData);
                                                        setSaveNeeded(true);
                                                    }
                                                }
                                            }}
                                        />
                                    ) : (
                                        <span>{campaignPitchRate.proposedRate || 'Not Set'}</span>
                                    )}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="border-top border rounded p-2 py-2">
                        <div className="mb-2 pb-2 border-bottom">Special Rates</div>
                        {isForm &&
                            <div className="d-flex align-items-center">
                                <div>Affiliate:</div>
                                <div className="w-100 ml-2">
                                    <AffiliateSearch
                                        setAffiliate={value => setAffiliateItem(index, value)}
                                        affiliate={affiliates[index]}
                                        order={order - index}
                                    />
                                </div>
                                <div>
                                    <button className="btn btn-link text-primary ml-2" onClick={(e) => { e.preventDefault(); addAffiliateToRate(campaignRate, index) }}>
                                        <FontAwesomeIcon icon={faPlus} />
                                    </button>
                                </div>
                            </div>
                        }
                        <div>
                            <table className="table table-sm table-hover w-100 mt-2">
                                <tbody>
                                    {
                                        campaignPitch.rates.filter(rate => {
                                            // Only show the rates where there is an affiliate and the ratename matches the current ratename
                                            return (rate.name == campaignPitchRate.name && rate.affiliate && rate.affiliate.id > 0);
                                        })
                                            .map((r) => {
                                                return (
                                                    r.affiliate ?
                                                        <SpecialRate key={`${r.name}-${r.affiliate.id}`} rate={r} campaign={campaign} isForm={isForm} isComplete={isComplete} status={status} />
                                                        :
                                                        <></>
                                                );
                                            })
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
            </div>

        )
    }

    return (
        <div className="card mt-3 m-1 w-100" style={{ backgroundColor: 'white' }} key={campaignPitch.id}>
            <div className="card-header d-flex align-items-center w-100 border-bottom">
                <div className="d-flex w-100 justify-content-between align-items-center">
                    <Campaign oid={campaignPitch.id} name={campaignPitch.name} />
                    {(status.code !== 'A' && status.code !== 'C' && status.code !== 'X' && status.code !== 'P') && (
                        <button className="btn btn-link text-danger" onClick={() => {
                            setSaveNeeded(true)
                            let tempData = { ...data }
                            tempData.pitch.campaignPitches = tempData.pitch.campaignPitches.filter(cp => cp.id !== campaignPitch.id)
                            setData(tempData)
                            //showSystemMessage('success', 'Campaign Pitch removed successfully')
                            //We don't want to show a message because no data was actually modified
                        }
                        }>
                            <FontAwesomeIcon icon={faMinus} />
                        </button>
                    )}
                </div>
            </div>
            <div className="card-body">
                {(status.code !== 'A' && status.code !== 'C' && status.code !== 'X' && status.code !== 'P') && (
                    <div className="d-flex justify-content-between ">
                        <select className="form-control form-control-sm" onChange={(e) => { setRate(campaign.rates.find(r => r.name === e.target.value)) }}>
                            <option value="">Select Rate</option>
                            {campaign.rates.map((r) => {
                                //if the rate is already added, skip it
                                if (campaignPitch.rates.find(cpr => cpr.name === r.name && !cpr.affiliate)) {
                                    return null;
                                }
                                if (!r.hidden) {
                                    return (
                                        <option key={r.name} value={r.name}>{r.name} - {r.description} {r.default_flag == 'Y' ? '[default]' : ''} - {r.net_rate_text} {r.display_net_rate_text ? '- Display: ' + r.display_net_rate_text : ''}</option>
                                    )
                                }
                            })}
                        </select>

                        <button className="btn btn-link text-primary" onClick={(e) => addRate(e)}>
                            <FontAwesomeIcon icon={faPlus} />
                        </button>

                    </div>
                )}
                {campaignPitch.rates && campaignPitch.rates.length > 0 && campaignPitch.rates
                    .filter(rate => {
                        // In the main list, show all the rates without affiliates
                        return (!rate.affiliate || !rate.affiliate.id);
                    })
                    .map((r, index) => {
                        return (
                            <Rate campaignPitchRate={r} campaignRate={campaign.rates.find(cr => cr.name === r.name)} key={r.id} index={index} isComplete={status.code === 'A'} isForm={!(status.code === 'D' || status.code === 'A' || status.code === 'C' || status.code === 'X')} status={status} />
                        );
                    })}
            </div>
        </div>
    )
}
export default CampaignPitch